import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate and useLocation

const ServiceSection = () => {
  const navigate = useNavigate();
  const location = useLocation(); // To read the query parameters from the URL
  const [activeTab, setActiveTab] = useState('tab2'); // Default active tab is tab2
  const [hoveredTab, setHoveredTab] = useState(''); // State to track hovered tab

  // Use URL query parameter to determine the active tab
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab) {
      setActiveTab(tab); // Update active tab based on the query parameter
    }
  }, [location.search]); // Re-run when the query parameter changes

  // Handle tab click and redirect
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    navigate(`/services?tab=${tabId}`); // Redirect to /services with the tab query parameter
  };

  // Handle mouse hover
  const handleMouseEnter = (tabId) => {
    setHoveredTab(tabId);
  };

  const handleMouseLeave = () => {
    setHoveredTab('');
  };

  // Determine which image to display based on the hoveredTab
  const getImageForTab = () => {
    switch (hoveredTab) {
      case 'tab1':
        return '/images/offer1.jpg'; // Local Cabs Image
      case 'tab2':
        return '/images/resource/service6-2.jpg'; // Outstation Cabs Image
      case 'tab3':
        return '/images/resource/service6-3.jpg'; // Airport Cabs Image
      case 'tab5':
        return '/images/offer2.jpg'; // One Way Cab Image
      default:
        return '/images/resource/service6-2.jpg'; // Default Image
    }
  };

  return (
    <section className="service-section-seven sec-title pt-4">
      <h2
        className="letters-slide-up text-split text-center pb-3 pb-md-5 sec-title mb-md-5"
        style={{ color: '#0C0095', fontFamily: 'Lucida Calligraphy', fontSize: '58px' }}
      >
        Our Offerings...
      </h2>

      <div className="auto-container">
        <div className="work-tabs tabs-box">
          <div className="row align-items-lg-center">
            {/* Title Column */}
            <div className="btn-column col-lg-6 col-md-4 col-md-12">
              <div className="inner-column">
                <ul className="tab-btns tab-buttons">
                  <li
                    className={`tab-btn ${activeTab === 'tab2' ? 'active-btn' : ''}`}
                    onClick={() => handleTabClick('tab2')} // Redirect to /services with the 'tab2' parameter
                    onMouseEnter={() => handleMouseEnter('tab2')} // Change image on hover
                    onMouseLeave={handleMouseLeave} // Reset image on hover leave
                  >
                    <span className="icon"><i className="flaticon-taxi-2"></i></span>
                    <span className="title">Outstation Cabs</span>
                  </li>
                  <li
                    className={`tab-btn ${activeTab === 'tab5' ? 'active-btn' : ''}`}
                    onClick={() => handleTabClick('tab5')} // Redirect to /services with the 'tab5' parameter
                    onMouseEnter={() => handleMouseEnter('tab5')} // Change image on hover
                    onMouseLeave={handleMouseLeave} // Reset image on hover leave
                  >
                    <span className="icon"><i className="flaticon-driver-3"></i></span>
                    <span className="title">One Way Cab</span>
                  </li>
                  <li
                    className={`tab-btn ${activeTab === 'tab1' ? 'active-btn' : ''}`}
                    onClick={() => handleTabClick('tab1')} // Redirect to /services with the 'tab1' parameter
                    onMouseEnter={() => handleMouseEnter('tab1')} // Change image on hover
                    onMouseLeave={handleMouseLeave} // Reset image on hover leave
                  >
                    <span className="icon"><i className="flaticon-taxi-4"></i></span>
                    <span className="title">Local Cabs</span>
                  </li>
                  <li
                    className={`tab-btn ${activeTab === 'tab3' ? 'active-btn' : ''}`}
                    onClick={() => handleTabClick('tab3')} // Redirect to /services with the 'tab3' parameter
                    onMouseEnter={() => handleMouseEnter('tab3')} // Change image on hover
                    onMouseLeave={handleMouseLeave} // Reset image on hover leave
                  >
                    <span className="icon"><i className="flaticon-mobile-app"></i></span>
                    <span className="title">Airport Cabs</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Image Column */}
            <div className="image-column col-lg-6 col-md-8 col-md-12">
              <div className="inner-column">
                <div className="tabs-content">
                  <div className="image-box">
                    <div className="inner-box">
                      <figure className="image reveal overlay-anim">
                        {/* Change image based on hoveredTab */}
                        <img src={getImageForTab()} alt="Service Image" />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
